import { inject, Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { Pagination } from '@api/abstracts/models';
import { Time } from '@shared/constants';
import { CurrentLanguageService } from '@shared/services/language/current-language.service';
import { CustomerReview, RatingDistribution } from '@shared/services/reviews/models';
import { envConfiguredNetworkId } from '@shared/utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReviewsService extends ApiServiceBase<unknown> {
  constructor() {
    super(
      `reviews/network/${envConfiguredNetworkId(inject(CurrentLanguageService).language.region)}`,
      'reviews',
      'fournierWebservice'
    );
  }

  getPercentageByRate(storeUuid?: string): Observable<RatingDistribution[]> {
    return this.read(
      'percentageByRate',
      { ...(storeUuid ? { storeUuid } : {}) },
      { cacheExpirationTime: Time.FOUR_HOURS }
    ) as Observable<RatingDistribution[]>;
  }

  getListOfReviews(filters: {
    pageNumber: number;
    itemsPerPage: number;
    note?: number;
    storeUuid?: string;
  }): Observable<Pagination<CustomerReview>> {
    const options: Record<string, string> = {
      page: String(filters.pageNumber),
      numberByPage: String(filters.itemsPerPage),
      ...(filters.note ? { note: String(filters.note) } : {}),
      ...(filters.storeUuid ? { storeUuid: filters.storeUuid } : {}),
    };
    return this.read('', options, {
      cacheExpirationTime: Time.FOUR_HOURS,
    }) as Observable<Pagination<CustomerReview>>;
  }
}
